import axios from 'axios';

import { store } from 'src/redux';

export const ApiClient = () => {
	const axiosInstance = axios.create({
		baseURL: '',
	});

	axiosInstance.interceptors.response.use(
		(response) => {
			if (typeof response.data === 'string') {
				return response;
			}
			return response;
		},
		(error) => errorHandler(error)
	);
	axiosInstance.interceptors.request.use((req) => {
		if (req.data.Skipinterceptors) {
			return req;
		} else {
			const seletctedPlant = store.getState().allPlants.plantName;
			const defaultValue = store.getState().allPlants.plants;
			req.data['plant_id'] = seletctedPlant.value
				? seletctedPlant.value
				: defaultValue[0]?.value;
			return req;
		}
	});

	const getInstance = () => {
		return axiosInstance;
	};

	const getHeader = () => {
		let returnHeader = {
			'Content-Type': 'application/json',
			Authorization: 'Bearer ' + store.getState().loginAuth.token,
		};
		return returnHeader;
	};
	return {
		getInstance,
		getHeader,
	};
};

const errorHandler = (error) => {
	return Promise.reject({ ...error });
};
